import "./About.scss";
import { init } from 'ityped'
import { useEffect, useRef } from "react";


export default function About() {


  const textRef = useRef()

  useEffect(() => {
    init(textRef.current, {
      showCursor: false,
      strings: ["<Programmer>", "Student","Gamer"],
    });

  }, [])


  return (
    <div className="About" id="about">
      <div className="profile">
        <img src="assets/Profiles.jpg" alt="" />
      </div>
      <h2>Anurag Sharma</h2>
      <span>  <p  ref={textRef}></p></span>
     
      <div className="aboutme">
        <h1>About Me</h1>
        <p>
          Hi, I am Anurag Sharma, currently a second-year engineering student, A
          software engineer with hands-on experience in all levels of Android
          Development and Full Stack Web Development expertise to build
          real-world projects. Proven ability to leverage full-stack expertise
          to build interactive and user-centered website designs to scale
        </p>
        <p>2021 Goals: Contribute more to Open Source projects</p>

        <p>
          I am eager to hear about potential career opportunities, so I would be
          pleased to chat about internship openings in the engineering sphere.
          My key skills include - Mobile Application Development, Full-Stack
          development, and Artificial Intelligence. If you want to know more
          about me, send me a message or reach out to me at
          <a href="sharma54anurag@gmail.com"> sharma54anurag@gmail.com</a>
        </p>
      </div>
      <div className="aboutme">
        <h1>Education</h1>
        <h3>Prof.Ram Meghe Institute of Technology & Research</h3>
        <h2>B.Tech in Computer Science and Engineering</h2>
      </div>
      <div className="aboutme">
        <h1>Internship Exprience</h1>
        <h2>Mobile Developer Intern</h2>
        <h3>Blue Berry e-Services Pvt. Ltd.</h3>

        <ul>
          <li>
            Developed a referral feature in Blueberry Rapiraadda Application and
            to solve the marketing problems
          </li>
          <li>
            developed a money transaction feature in Rapiraadda vendor android
            application and redesign wallet UI from scratch and give a new look
            to the application.
          </li>
          <li>
            Build a New project called ShramIn from Scratch and Launch
            application 1st version 1.0.0 on the play store. this is a job
            posting platform for blue-collar workers.
          </li>
        </ul>
      </div>
      <div className="skills">
        <h1>Skills and Proficiency</h1>
        <h2>Programming / Markup Languages </h2>

        <div className="skills-list">
          <div className="rowOne">
            <ul>
              <li>JavaScript , Typescript</li>
              <li>Python</li>
              <li>C++</li>
              <li>C</li>
              <li>Dart</li>
              <li>Kotlin</li>
              <li>HTML/CSS/Scss</li>
            </ul>
          </div>
        </div>
        <br />
        <h2> Frameworks </h2>

        <div className="skills-list">
          <div className="rowOne">
            <ul>
              <li>React Native</li>
              <li>AWS</li>
              <li>Firebase</li>
              <li>React</li>
              <li>MERN</li>
              <li>Express</li>
              <li>Django</li>
              <li>Flutter</li>
            </ul>
          </div>
          <div className="rowOne">
            <ul>
              <li>Tensorflow</li>
              <li>OpenCV</li>
              <li>Keras</li>
              <li>Stable Baseline</li>
              <li>Pandas</li>
              <li>Numpy</li>
            </ul>
          </div>
        </div>
        <br />
        <h2> System / Platform / Tools </h2>
        <div className="skills-list">
          <div className="rowOne">
            <ul>
              <li>Linux</li>
              <li>Mac</li>
              <li>Windows</li>
              <li>Android</li>
            </ul>
          </div>
          <div className="rowOne">
            <ul>
              <li>Postman / Insomia</li>
              <li>git</li>
              <li>tensorboard</li>
              <li>Docker</li>
              <li>heroku</li>
            </ul>
          </div>
        </div>

        <br />
      </div>
      <h4>Made with ❤️ by Anurag Sharma ( V-1.0.0 )</h4>
    </div>
  );
}
